import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { CompleteProfile } from "@/features/auth/components/CompleteProfile";
import { ConfigProvider, fetchConfig } from "@/lib/config";
import { fetchUser } from "@/lib/user";

export const Route = createFileRoute("/complete-profile")({
  beforeLoad: async ({ search }) => {
    const [user, config] = await Promise.all([fetchUser(), fetchConfig()]);

    if (!user?.user) {
      throw redirect({
        to: "/login",
        search,
      });
    }

    // If user doesn't need profile completion, redirect to home
    if (!user.user["https://blis.app/profile"].needsProfileCompletion) {
      throw redirect({
        to: "/",
        search,
      });
    }

    return { config };
  },
  validateSearch: z.object({ next: z.string().prefault("/") }),
  component: CompleteProfileRoute,
});

function CompleteProfileRoute() {
  const { next } = Route.useSearch();
  const { config } = Route.useRouteContext();

  return (
    <ConfigProvider config={config}>
      <CompleteProfile next={next} />
    </ConfigProvider>
  );
}
